import { Injectable } from '@angular/core';
import { CustomerInterface } from '../models/customer.interface';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { CryptService } from '../../shared/services/crypt.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerStorageService {

  constructor(
      private cryptService: CryptService,
      private cookieService: CookieService,
  ) {}

  /**
   * Get customer information
   */
  getCustomer(): CustomerInterface|null {
    const customerExtranet = 'customerExtranet';
    if (this.cookieService.get(customerExtranet)) {
      localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN);
      localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER, this.cookieService.get(customerExtranet));
      this.cookieService.delete(customerExtranet, '/', environment.data.cookiesDomain, false, 'Strict');
      setTimeout(() => {
        const tokenDetails = JSON.parse(this.cryptService.decrypt(this.cookieService.get(ConstsHelper.COOKIE_CUSTOMER_TOKEN)));
        if (tokenDetails.isAdminProFleet) {
          localStorage.setItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN, tokenDetails.token);
        }
      }, 2000);
      return JSON.parse(this.cryptService.decrypt(localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER)));
    } else if (localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER) != null) {
      return JSON.parse(this.cryptService.decrypt(localStorage.getItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER)));
    }
    return null;
  }

  /**
   * Save customer information
   */
  save(data: CustomerInterface): void {
    localStorage.setItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER, this.cryptService.encrypt(JSON.stringify(data)));
  }

  /**
   * this is used to clear anything that needs to be removed
   */
  clear(): void {
    localStorage.removeItem(ConstsHelper.LOCAL_STORAGE_CUSTOMER);
    this.cookieService.delete(ConstsHelper.COOKIE_CUSTOMER_TOKEN, '/', environment.data.cookiesDomain);
    this.cookieService.delete(environment.data.brand + '_ec', '/', environment.data.cookiesDomain);
  }
}
